module.exports = __webpack_public_path__ + "prod/20260124143402/img/experience.942f4ebf.png";